import { render, staticRenderFns } from "./otpVerifyPopup.vue?vue&type=template&id=31eaa3d0&scoped=true"
import script from "./otpVerifyPopup.vue?vue&type=script&lang=js"
export * from "./otpVerifyPopup.vue?vue&type=script&lang=js"
import style0 from "./otpVerifyPopup.vue?vue&type=style&index=0&id=31eaa3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eaa3d0",
  null
  
)

export default component.exports